import Vue from 'vue';
import EStorage from '@beetronix/estorage';

Vue.use(EStorage);

const eStorage = new EStorage({
	l: {
		staticKeys: ['lang']
	}
});

export { eStorage }